import './index.css';
import '@gojitsu/web-ui-core/css/variables';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';

const rumApplicationId = import.meta.env.VITE_RUM_APPLICATION_ID || import.meta.env.REACT_APP_RUM_APPLICATION_ID;
const rumClientToken = import.meta.env.VITE_RUM_CLIENT_TOKEN || import.meta.env.REACT_APP_RUM_CLIENT_TOKEN;

if (rumApplicationId && rumClientToken) {
  datadogRum.init({
    applicationId: rumApplicationId,
    clientToken: rumClientToken,
    site: 'datadoghq.com',
    service: 'dsp-app',
    env: import.meta.env.VITE_RUM_ENV || import.meta.env.REACT_APP_RUM_ENV,
    version: import.meta.env.VITE_RUM_VERSION || import.meta.env.REACT_APP_RUM_VERSION,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
